<script>
  import { trackLinkClick } from '../../../../../../js/trackLinkClick';
  import { getAccessibilityRedesignRenderState } from '../../../../../../js/stores';

  import SpotlightImage, { IMAGE_WIDTH } from './SpotlightImage/SpotlightImage.svelte';
  import ArrowLink from './ArrowLink/ArrowLink.svelte';
  import Link from './Link/Link.svelte';

  // Props
  export let id = '';
  export let image = null;
  export let url = '';
  export let linkText = '';
  export let description = '';

  const accessibilityRedesignRenderStore = getAccessibilityRedesignRenderState();
</script>

<div {id} class="SpotlightItem" style="--spotlight-item-text-container-width: {IMAGE_WIDTH}px;">
  <a
    {id}
    class:focus-accessibility-redesign={$accessibilityRedesignRenderStore}
    href={url}
    use:trackLinkClick={{
      id,
      title: linkText,
      url,
    }}
  >
    {#if image}
      <SpotlightImage id={image.id} description={image.description} url={image.url} />
    {/if}
  </a>
  <div class="spotlight-item-text-container">
    {#if $accessibilityRedesignRenderStore}
      <Link {id} {linkText} {url} ariaLabel={description} />
    {:else}
      <ArrowLink {id} {linkText} {url} ariaLabel={description} />
    {/if}
    <span class="spotlight-item-description">{description}</span>
  </div>
</div>

<style>@charset "UTF-8";
.SpotlightItem {
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
  gap: 16px;
}

.spotlight-item-text-container {
  display: flex;
  flex-direction: column;
  max-width: var(--spotlight-item-text-container-width);
  gap: 4px;
}

.spotlight-item-description {
  font-family: "Square Sans Text VF", "Square Sans Text", "Helvetica", "Arial", "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", "メイリオ", meiryo, "ＭＳ Ｐゴシック", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
}

.focus-accessibility-redesign:focus-visible:not(:active) {
  outline-offset: 2px;
  outline: 2px auto Highlight;
  outline: 2px auto -webkit-focus-ring-color;
}</style>
